import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { FooterLink, HeaderLink } from "@/types";

import { fetchFooterNavigation, fetchHeaderNavigationLinks } from "./thunk";

export interface NavigationLinksState {
  headerLinks: Partial<HeaderLink[]>;
  footerLinks: Partial<FooterLink[]>;
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: NavigationLinksState = {
  headerLinks: [],
  footerLinks: [],
  error: null,
  status: "idle"
};

export const navigationLinksSlice = createSlice({
  name: "navigationLinks",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[navigationLinksSlice.name]
        };
      })
      .addCase(fetchHeaderNavigationLinks.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchHeaderNavigationLinks.fulfilled, (state, action) => {
        state.status = "idle";
        state.headerLinks = action.payload;
      })
      .addCase(fetchHeaderNavigationLinks.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      })
      .addCase(fetchFooterNavigation.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchFooterNavigation.fulfilled, (state, action) => {
        state.status = "idle";
        state.footerLinks = action.payload;
      })
      .addCase(fetchFooterNavigation.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
